import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { NAV_LINKS } from "@/data/content";

export function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  useEffect(() => { setOpen(false); }, [location.pathname]);

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,border-color,backdrop-filter] duration-300 ${scrolled ? "border-b border-white/10 bg-[#090B0E]/80 backdrop-blur-xl" : "border-b border-transparent bg-transparent"}`} data-testid="main-navbar">
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 lg:px-10">
        <Link to="/" className="flex items-center gap-2.5" data-testid="logo-link">
          <img src="/imperium-logo.jpg" alt="Imperium Group logo" className="h-11 w-11 rounded-lg object-cover ring-1 ring-[#FF4500]/40" />
          <span className="font-display text-lg font-bold tracking-tight text-white">Imperium<span className="text-[#FF4500]"> Group</span></span>
        </Link>

        <div className="hidden items-center gap-8 lg:flex">
          {NAV_LINKS.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.to === "/"} data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) => `text-sm font-medium transition-colors duration-200 hover:text-[#FF4500] ${isActive ? "text-[#FF4500]" : "text-slate-300"}`}>
              {l.label}
            </NavLink>
          ))}
        </div>

        <div className="hidden lg:block">
          <Link to="/offerte" data-testid="nav-cta-btn" className="rounded-xl bg-[#FF4500] px-6 py-2.5 text-sm font-semibold text-[#090B0E] transition-[background-color,transform] duration-200 hover:bg-[#ff6428] hover:scale-[1.02]">
            Offerte aanvragen
          </Link>
        </div>

        <button className="text-white lg:hidden" onClick={() => setOpen((v) => !v)} data-testid="mobile-menu-toggle" aria-label="Menu">
          {open ? <X className="h-7 w-7" /> : <Menu className="h-7 w-7" />}
        </button>
      </nav>

      {open && (
        <div className="border-t border-white/10 bg-[#090B0E]/97 backdrop-blur-xl lg:hidden" data-testid="mobile-menu">
          <div className="flex flex-col gap-1 px-6 py-4">
            {NAV_LINKS.map((l) => (
              <NavLink key={l.to} to={l.to} end={l.to === "/"} className={({ isActive }) => `rounded-lg px-3 py-3 text-base transition-colors ${isActive ? "bg-white/5 text-[#FF4500]" : "text-slate-200"}`}>{l.label}</NavLink>
            ))}
            <Link to="/offerte" className="mt-2 rounded-xl bg-[#FF4500] px-3 py-3 text-center font-semibold text-[#090B0E]">Offerte aanvragen</Link>
          </div>
        </div>
      )}
    </header>
  );
}
